const ordersTypes = {
  SET_ORDER_NUMBER: "SET_ORDER_NUMBER",
  GET_ORDERS: "GET_ORDERS",
  ADD_ORDER: "ADD_ORDER",
  LOADING_ORDERS: "LOADING_ORDERS",
};
export default ordersTypes;
